module.exports = __webpack_public_path__ + "img/Entia-Carreteras-y-edificaciones-9.112c92bb.webp";